export default __webpack_public_path__ + "static/media/E-House Overview_V.2.119179f2.png";